export const COMMIT = '1b836f081501cc2ff2dca4809a6bc853a5d7b4ae';
export const TAG = '3.0.0';
